import BookCard from "./BookCard";

export default BookCard;
